import { Sidebar, SidebarClasses } from 'react-admin';

// El sidebar de react-admin (RaLayout > RaLayout-contentWithSidebar, un flex row) vive al
// lado del contenido principal como hermanos flex -- por defecto ambos se estirarian al
// mismo alto (align-items:stretch), pero el propio Sidebar.tsx de react-admin le fija un
// alto FIJO a su Drawer raiz (height: calc(100vh - 3em), pensado solo para pantallas cortas)
// que le impide crecer si el contenido principal es mas alto que un viewport. Por eso en
// pantallas largas, al hacer scroll, el fondo blanco del sidebar se termina antes que el
// contenido y se ve el gris de RaLayout por debajo. La solucion NO es fijar el sidebar con
// position:fixed (se probo y hizo que el panel completo desapareciera -- el Drawer
// "permanent" de MUI depende de position:relative internamente para su propio calculo de
// ancho/anclaje). En vez de eso, se libera el alto (height:auto, con un minHeight igual al
// que traia por defecto para que pantallas cortas se sigan viendo bien) para que el sidebar
// pueda estirarse junto con el contenido, aprovechando el align-items:stretch que ya trae el
// flex row de RaLayout.
const MySidebar = (props) => {
    return (
      <Sidebar
        sx={{
          height: 'auto',
          minHeight: 'calc(100vh - 3em)',
          [`& .${SidebarClasses.paper}`]: { backgroundColor: 'white' },
        }}
        {...props}
      />
    );
  };

  export default MySidebar;